// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminConfiguration = (client) => ({
    /**
     * `POST /admin/configuration`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateRule
     * @source packages/modules/b2c-core/src/api/admin/configuration/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/configuration", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/configuration`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListRules
     * @source packages/modules/b2c-core/src/api/admin/configuration/route.ts
     */
    list: (query, headers) => client.fetch("/admin/configuration", { method: "GET", query, headers }),
    /**
     * `POST /admin/configuration/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateRule
     * @source packages/modules/b2c-core/src/api/admin/configuration/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/configuration/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=configuration.js.map